import { makeStyles, tokens } from '@fluentui/react-components';

// Shared styles for the invitation "Help resources" main drawer and its stacked detail drawer.
// Mirrors the visual language of the sign-in troubleshoot drawer so the two experiences feel
// consistent.
export const useHelpResourcesDrawerStyles = makeStyles({
  body: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: tokens.spacingVerticalL,
  },
  introText: {
    display: 'block',
    color: tokens.colorNeutralForeground2,
    marginBottom: tokens.spacingVerticalM,
  },
  // Two cards on the first row and one card on the second row.
  optionCards: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: tokens.spacingHorizontalS,
  },
  optionCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: tokens.spacingVerticalS,
    padding: tokens.spacingVerticalM,
    minHeight: '131px',
    boxSizing: 'border-box',
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
    borderRadius: tokens.borderRadiusMedium,
    cursor: 'pointer',
    backgroundColor: tokens.colorNeutralBackground1,
    textAlign: 'left',
    ':hover': {
      backgroundColor: tokens.colorNeutralBackground1Hover,
    },
  },
  optionIcon: {
    flexShrink: 0,
    color: tokens.colorNeutralForeground2,
  },
  optionTitle: {
    display: 'block',
    color: tokens.colorNeutralForeground1,
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightSemibold,
  },
  optionSubtitle: {
    display: 'block',
    color: tokens.colorNeutralForeground3,
  },
  supportSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
    marginTop: 'auto',
    paddingTop: tokens.spacingVerticalL,
    paddingBottom: tokens.spacingVerticalM,
    borderBottom: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
  },
  supportCaption: {
    color: tokens.colorNeutralForeground3,
  },
  footer: {
    borderTop: 'none',
  },
  // Detail drawer: expandable question / answer / what-to-do entries.
  detailList: {
    display: 'flex',
    flexDirection: 'column',
    '& .fui-AccordionHeader__button': {
      minHeight: '44px',
      paddingLeft: 0,
      paddingRight: 0,
    },
    '& .fui-AccordionPanel': {
      marginLeft: 0,
      marginRight: 0,
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  detailItem: {
    borderBottom: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
    ':last-child': {
      borderBottom: 'none',
    },
  },
  detailTitle: {
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightSemibold,
  },
  detailPanel: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
    margin: 0,
    paddingLeft: 0,
    paddingRight: 0,
    paddingBottom: tokens.spacingVerticalM,
  },
  detailDescription: {
    color: tokens.colorNeutralForeground2,
  },
  detailWhatToDo: {
    color: tokens.colorNeutralForeground2,
  },
  detailWhatToDoLabel: {
    display: 'block',
  },
});
